export default __webpack_public_path__ + "static/media/mascote-cabeca.7fe3123d.webp";